import { useParams } from "react-router-dom";
import useCallApiUrl from "hook/useCallApiUrl";
import Loading from "components/Loading";
import { formatterCreateAt } from "components/Function";

const PostDetail = () => {
    const { slug } = useParams();
    const { data, loading } = useCallApiUrl(`/api/posts/${slug}`, null, Boolean(slug));

    if (loading) return <Loading isLoading={true} />;
    if (!data?.data) return <p>Post Not Found</p>;
    return (
        <div className="container mt-5">
            <div className="card shadow">
                <div className="card-body">
                    <h2 className="card-title">{data?.data.title}</h2>
                    <p className="card-text text-muted">Created At: {formatterCreateAt(data?.data.created_at)()}</p>
                    <hr />
                    <div className="card-text" dangerouslySetInnerHTML={{ __html: data?.data.content }} />
                </div>
            </div>
        </div>
    );
};

export default PostDetail;
